import SectionCta, {
  type CtaVariant,
} from '@modules/common/components/section-cta';
import { Text } from '@modules/common/components/text';

export type CtaLink = {
  label: string;
  href: string;
  variant: CtaVariant;
  ariaLabel?: string;
};

type ProductSliderHeaderProps = {
  overline?: string | null;
  title: string;
  description?: string;
  ctas?: CtaLink[] | null;
};

const ProductSliderHeader = ({
  overline,
  title,
  description,
  ctas,
}: ProductSliderHeaderProps) => (
  <div className="flex flex-col gap-5">
    <div className="flex flex-col gap-3">
      {overline ? (
        <Text className="text-sm font-normal uppercase text-fg-neutral-strong">
          {overline}
        </Text>
      ) : null}
      <h2
        id="product-slider-heading"
        className="text-6xl desktop:text-7xl font-heading font-light text-fg-neutral-strong leading-[1.125]"
      >
        {title}
      </h2>
    </div>
    {description ? (
      <Text className="text-base font-normal text-fg-neutral-strong">
        {description}
      </Text>
    ) : null}
    {ctas && ctas.length > 0 ? (
      <div className="flex flex-wrap gap-3">
        {ctas.map((cta) => (
          <SectionCta
            key={cta.href}
            label={cta.label}
            href={cta.href}
            variant={cta.variant}
            ariaLabel={cta.ariaLabel}
          />
        ))}
      </div>
    ) : null}
  </div>
);

export default ProductSliderHeader;
